import { Component, Inject, OnInit, Optional, ViewChild } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { ConfirmDialogComponent } from "../material-module/confirm-dialog/confirm-dialog.component";
import { Incarico } from "../models/incarico";
import { IncaricoService } from "../services/incarico.service";
import { dataTableColumnDefinition } from "../shared/resourceful-index/dataTableColumnDefinition";
import { ResourcefulIndexComponent } from "../shared/resourceful-index/resourceful-index/resourceful-index.component";
import { FormIncarichiComponent } from "./form/form.component";

@Component({
  selector: "incarichi",
  templateUrl: "./incarichi.component.html",
  styleUrls: ["./incarichi.component.scss"],
})
export class IncarichiComponent implements OnInit {
  headingText: string = "Incarichi";

  relations: string[] = [
    "polizza.compagnia",
    "polizza.contraente",
    "stato",
    "ispettorato",
    "studio",
    "incaricato",
    "incaricato.filiale",
    "liquidatore",
    "tipo_danno",
  ];

  @ViewChild("index") index: ResourcefulIndexComponent;

  selectionMode: boolean = false;

  loading: boolean = true;

  search: any = {};

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition({
      humanName: "Numero",
      internalName: "humanIdentifier",
      type: "link",
      href: (model) => model.id,
    }),
    new dataTableColumnDefinition({
      humanName: "Stato",
      internalName: "state",

      sortDisabled: true,
      displayFunction: (model) => model.stato?.nome,
    }),
    new dataTableColumnDefinition({
      humanName: "Compagnia",
      internalName: "compagnia",

      sortDisabled: true,
      displayFunction: (model) => model.polizza?.compagnia?.nome,
    }),
    new dataTableColumnDefinition({
      humanName: "Sinistro",
      internalName: "numero_sinistro",
    }),
    new dataTableColumnDefinition({
      humanName: "Ispettorato",
      internalName: "ispettorato",

      sortDisabled: true,
      displayFunction: (model) => model.ispettorato?.nome,
    }),
    new dataTableColumnDefinition({
      humanName: "Data sinistro",
      internalName: "data_sinistro",
      type: "date",
    }),
    new dataTableColumnDefinition({
      humanName: "Data sopralluogo",
      internalName: "data_sopralluogo",
      type: "date",
    }),
    new dataTableColumnDefinition({
      humanName: "Contraente",
      internalName: "contraente",

      sortDisabled: true,
      displayFunction: (model: Incarico) =>
        model.polizza?.contraente?.humanIdentifier,
    }),
    new dataTableColumnDefinition({
      humanName: "Tipo danno",
      internalName: "tipo_danno",

      sortDisabled: true,
      displayFunction: (model: Incarico) => model.tipo_danno?.nome,
    }),

    new dataTableColumnDefinition({
      humanName: "Data incarico",
      internalName: "data",
      type: "date",
    }),
    new dataTableColumnDefinition({
      humanName: "Aperto da",
      internalName: "aperto_da",
      sortDisabled: true,
      type: "string",
      displayFunction: (model: Incarico) => "" + (model.apertoDa || 0) + " g",
    }),
    new dataTableColumnDefinition({
      humanName: "Incaricato",
      internalName: "incaricato",

      sortDisabled: true,
      displayFunction: (model) => model.incaricato?.humanIdentifier,
    }),
    new dataTableColumnDefinition({
      humanName: "Data Spedizione",
      type: "date",
      internalName: "data_spedizione",
    }),
    new dataTableColumnDefinition({
      humanName: "Liquidatore",
      internalName: "liquidatore",
      displayFunction: (model) => {
        let liq = "";
        if (model?.liquidatore?.nome) liq = model?.liquidatore?.nome + " ";
        if (model?.liquidatore?.cognome) liq += model?.liquidatore?.cognome;
        return liq;
      },
    }),
    new dataTableColumnDefinition({
      humanName: "Riserva di Danno",
      internalName: "riserva_di_danno_range",
      displayFunction: (model) => {
        return model?.riserva_di_danno_range || model?.riserva_di_danno;
      },
    }),
    new dataTableColumnDefinition({
      humanName: "Concordato",
      internalName: "concordato",
      displayFunction: (model) => (model?.concordato ? "Sì" : "No"),
    }),
    new dataTableColumnDefinition({
      humanName: "Pronta liquidazione",
      internalName: "pronta_liquidazione",
      displayFunction: (model) => (model?.pronta_liquidazione ? "Sì" : "No"),
    }),
    new dataTableColumnDefinition({
      humanName: "Riserva",
      internalName: "riserva",
      displayFunction: (model) => (model?.riserva ? "Sì" : "No"),
    }),
    new dataTableColumnDefinition({
      humanName: "Liquidato",
      internalName: "indennizzo_risarcimento",
      type: "currency",
    }),
    new dataTableColumnDefinition({
      humanName: "Studio",
      internalName: "studio",

      sortDisabled: true,
      displayFunction: (model) => model.studio?.nome,
    }),
    new dataTableColumnDefinition({
      humanName: "Filiale",
      internalName: "filiale",

      displayFunction: (model) => model.incaricato?.filiale?.nome,
    }),
  ];
  constructor(
    public incaricoService: IncaricoService,
    public dialog: MatDialog,
    private toast: ToastrService,
    @Optional() private dialogRef: MatDialogRef<IncarichiComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    if (this.data?.selectionMode) {
      this.selectionMode = true;
      this.headingText = "Seleziona un incarico";
    }
  }

  async ngOnInit() {
    this.loading = false;
  }

  closeDialogWithSelectedModel(model) {
    this.dialogRef?.close(model);
  }

  async updateDataSource() {
    await this.index?.updateData();
  }

  deleteFunction = async (incarico: Incarico) => {
    try {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, {
        data: {
          message: `Sei sicuro di voler eliminare l'incarico ${incarico.humanIdentifier}?`,
        },
      });
      dialogRef.afterClosed().subscribe(async (data) => {
        if (data) {
          await this.incaricoService.delete(incarico);
          this.toast.success("Incarico eliminato.");
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Eliminazione incarico fallita.", "Errore!");
    }
  };

  editFunction = async (incarico: Incarico) => {
    try {
      let dialogRef = this.dialog.open(FormIncarichiComponent, {
        data: incarico,
      });
      dialogRef.afterClosed().subscribe(() => {
        this.updateDataSource();
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Modifica incarico fallita.", "Errore!");
    }
  };

  add() {
    try {
      let addDialogRef = this.dialog.open(FormIncarichiComponent, {
        autoFocus: false,
      });
      addDialogRef.afterClosed().subscribe((data) => {
        this.updateDataSource();
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Modifica incarico fallita.", "Errore!");
    }
  }
}
